export default [
  {
    name: 'Date',
    selector: (row) => row.attributes.format_date,
    sortable: true,
    sortFunction: (a, b) => a.attributes.formated_date_int - b.attributes.formated_date_int,
  },
  {
    name: 'Payment #',
    selector: (row) => row.attributes.number,
    sortable: true,
  },
  {
    name: 'Deduction',
    selector: (row) => row.attributes.format_deduction,
    sortable: true,
    right: true,
  },
];
